import { render } from "./ThemeColorSnippet.vue?vue&type=template&id=1c282df2&scoped=true"
import script from "./ThemeColorSnippet.vue?vue&type=script&lang=js"
export * from "./ThemeColorSnippet.vue?vue&type=script&lang=js"

import "./ThemeColorSnippet.vue?vue&type=style&index=0&id=1c282df2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c282df2"]])

export default __exports__